import React from 'react'

import { Hangman, Secret, Fails } from '../index'
import "./Board.css"

const Board = ({secret, correctLetters, wrongLetters }) => {
    return (
            <div className="game-board">
                <div className="game-board__figure">
                    <Hangman wrongLetters={wrongLetters} />
                    <Fails wrongLetters={wrongLetters} />
                </div>
                <div className="game-board__letters">
                    <b>Press letters from the keyboard to make a guess</b><br/>
                    <p><b>Hint: </b><i>It's a country</i></p>

                    <Secret secret={secret} correctLetters={correctLetters} />
                </div>
            </div>
    )
}

export default Board